"use strict";
document.addEventListener("DOMContentLoaded", function () {
    const loginForm = document.getElementById("login_form");
    if (loginForm) {
        // パスワード入力欄とログインボタンの要素を取得
        const passwordInput = document.getElementById("login-password");
        const submitButton = document.getElementById("login-submit") || null;
        // 初期状態でボタンを無効化（パスワードが空の場合）
        if (passwordInput && submitButton) {
            submitButton.disabled = passwordInput.value.length === 0;
            // 入力欄の変更を監視
            passwordInput.addEventListener("input", function () {
                // パスワードが空の場合はボタンを無効化、そうでなければ有効化
                submitButton.disabled = passwordInput.value.length === 0;
            });
        }
    }
});
